import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardStats = ({ stats }) => {
  const statItems = [
    {
      id: 'total',
      title: 'Total Planners',
      value: stats?.totalPlanners || 0,
      icon: 'FileText',
      color: 'primary',
      change: stats?.totalChange || '+12%',
      changeType: 'positive'
    },
    {
      id: 'completed',
      title: 'Completed',
      value: stats?.completedPlanners || 0,
      icon: 'CheckCircle',
      color: 'success',
      change: stats?.completedChange || '+8%',
      changeType: 'positive'
    },
    {
      id: 'downloads',
      title: 'Total Downloads',
      value: stats?.totalDownloads || 0,
      icon: 'Download',
      color: 'accent',
      change: stats?.downloadChange || '+24%',
      changeType: 'positive'
    },
    {
      id: 'templates',
      title: 'Saved Templates',
      value: stats?.savedTemplates || 0,
      icon: 'Bookmark',
      color: 'secondary',
      change: stats?.templateChange || '+3%',
      changeType: 'positive'
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'primary':
        return 'bg-primary/10 text-primary';
      case 'success':
        return 'bg-success/10 text-success';
      case 'accent':
        return 'bg-accent/10 text-accent';
      case 'secondary':
        return 'bg-secondary/10 text-secondary';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const formatNumber = (num) => {
    if (num >= 1000) {
      return (num / 1000)?.toFixed(1) + 'k';
    }
    return num?.toString();
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {statItems?.map((stat) => (
        <div
          key={stat?.id}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-all duration-200"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`
              w-12 h-12 rounded-lg flex items-center justify-center
              ${getColorClasses(stat?.color)}
            `}>
              <Icon name={stat?.icon} size={24} />
            </div>
            
            <div className={`
              px-2 py-1 rounded-full text-xs font-caption
              ${stat?.changeType === 'positive' ?'bg-success/10 text-success' :'bg-destructive/10 text-destructive'
              }
            `}>
              {stat?.change}
            </div>
          </div>
          
          <div>
            <div className="font-heading text-2xl font-bold text-foreground mb-1">
              {formatNumber(stat?.value)}
            </div>
            <div className="font-body text-sm text-muted-foreground">
              {stat?.title}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;